/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForProviderRecommendations extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForProviderRecommendations");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForProviderRecommendations.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForProviderRecommendations>): BackgroundJobPayloadForProviderRecommendations {
        let obj = Object.assign(new BackgroundJobPayloadForProviderRecommendations(), model);
        BackgroundJobPayloadForProviderRecommendations.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForProviderRecommendations>): BackgroundJobPayloadForProviderRecommendations {
        if (!model) return null;
        return BackgroundJobPayloadForProviderRecommendations.newInstance(<BackgroundJobPayloadForProviderRecommendations> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForProviderRecommendations) {
        if (!obj) return;

        models.BackgroundJobPayloadForProviderRecommendations.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForProviderRecommendations): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForProviderRecommendations.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

    /**
     * Cloud service for which to execute ProviderRecommendation (use only cloud_service or integrated_tools, not both)
     */
    cloud_service: models.CloudServiceName;

    /**
     * Integrated tool for which to execute ProviderRecommendation (use only cloud_service or integrated_tools, not both)
     */
    integrated_tool: models.IntegratedToolName;

    /**
     * Indicates an \"on demand\" request when True
     */
    on_demand: boolean;

}
